<template>
  <div class="main-layout">
    <div class="container mt-3 main-content">
      <Child />
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/PcsNavbar'
import Modal from '~/components/modal'
import Websocket from '~/components/Websocket'

import { mapGetters, mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'MainLayout',

  components: {
    Navbar,
    Modal,
    Websocket,
  },

  computed: {
    ...mapState({
      // chat: state => state.chat.showChat,
    }),
  },

  created: function() {
    localStorage.setItem('path', 'disasterresponse')
  },

  watch: {},
}
</script>

<style scoped lang="scss">
.main-layout{
  display:flex;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.main-content {
  flex-grow: 1;
  flex-shrink: 1;
  height: inherit;
  overflow-y: auto;
  max-width: 100% !important;
  min-width:0;
  margin: 0 !important;
  padding: 5px;
}
</style>
